import {ToastOptions} from "react-toastify";

/**
 * Types of the application toasts.
 */
export enum ToastTypes {
    apiResponseError = 'apiResponseError',
    apiResponseSuccess = 'apiResponseSuccess',
    success = 'success',
    error = 'error',
    warning = 'warning',
    info = 'info',
}

export interface IToastOptions extends Omit<ToastOptions, 'data'> {
}


export interface UIUtilsEventTypes {
    'pwa-installable': (installable: boolean) => void;
    'pwa-running': (isPWA: boolean) => void;
}
